import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OktaAuthService } from 'src/app/core/services/http/okta-auth.service';
import { Cached } from '../shared/cached';
import { IMultiTenantSystemPermissions, IProfile } from '../TODO/interfaces';
import { throwWhenUndefined } from '../util/throw-when-undefined';
import { UrlService } from './url.service';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    private readonly profile: Cached<IProfile | undefined> = new Cached<IProfile>(() =>
        this.oktaAuth.getUser().then(
            user =>
                <IProfile>{
                    userName: user.username,
                    fullUserName: user.fullName
                }
        )
    );
    private readonly permissions: Observable<IMultiTenantSystemPermissions[]> = of([
        {
            tenantId: 'DEV1',
            systemPermissions: {
                canCreateApplication: true,
                canDeleteApplication: true,
                canExportApplication: true,
                canImportApplication: true,
                canManageLookupLists: true,
                canManageUsers: true
            }
        },
        {
            tenantId: 'DEV2',
            systemPermissions: {
                canCreateApplication: true,
                canDeleteApplication: true,
                canExportApplication: true,
                canImportApplication: true,
                canManageLookupLists: true,
                canManageUsers: true
            }
        },
        {
            tenantId: 'default',
            systemPermissions: {
                canCreateApplication: true,
                canDeleteApplication: true,
                canExportApplication: true,
                canImportApplication: true,
                canManageLookupLists: true,
                canManageUsers: true
            }
        }
    ]);

    public constructor(
        private http: HttpClient,
        private url: UrlService,
        private oktaAuth: OktaAuthService
    ) {}

    public getAccount(): Promise<IProfile> {
        return throwWhenUndefined(this.profile.getValue());
    }

    public getSystemPermissions(): Observable<IMultiTenantSystemPermissions[]> {
        return this.http.get<IMultiTenantSystemPermissions[]>(this.url.createApiUrl(`account/permissions`));
    }

    public clearUserCache() {
        const url = this.url.createApiUrl(`account/clearusercache`);
        return this.http.delete(url).toPromise();
    }
}
